import {
  FETCH_USER_PROFILE,
  AUTH_PROFILE_UPDATE,
  FETCH_TRANSLATIONS,
  CHECK_MODULE_PERMISSIONS
} from './types';


const BACKEND_API = 'BACKEND_API';

export const updateUserProfile = profile => ({
  type: AUTH_PROFILE_UPDATE,
  payload: profile
});


export const fetchUserProfile = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/portal/profile/'
    },
    FETCH_USER_PROFILE
  )
});

export const fetchTranslations = () => ({
  type: BACKEND_API,
  payload: Object.assign(
    {
      method: 'get',
      url: '/airports/translations/'
    },
    FETCH_TRANSLATIONS
  )
});

export const checkSomeModulesPermission = modulePermission => ({
  type: CHECK_MODULE_PERMISSIONS,
  payload: modulePermission
});
